module.exports = __webpack_public_path__ + "static/media/ico_cross.a622d8df.svg";